var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowIcmpFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flow-icmp-fill_svg__clip0_2193_2246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22h-3V10h3v12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: -0.82,
    width: 23.796,
    height: 23.796,
    rx: 2,
    transform: "rotate(45 16 -.82)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10v3h-5v9h-3V10h8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15h5v3h-5v-3zM22.5 22h-3V10h3v12z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flow-icmp-fill_svg__clip0_2193_2246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#fff"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIxOTNfMjI0NikiPgo8cGF0aCBkPSJNMTcuNSAyMkgxNC41VjEwSDE3LjVWMjJaIiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSIxNiIgeT0iLTAuODIwMDA3IiB3aWR0aD0iMjMuNzk2MiIgaGVpZ2h0PSIyMy43OTYyIiByeD0iMiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTYgLTAuODIwMDA3KSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik0xNy41IDEwVjEzSDEyLjVWMTVWMThWMjJIOS41VjEwSDE3LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMTIuNSAxNUgxNy41VjE4SDEyLjVWMTVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNMjIuNSAyMkgxOS41VjEwSDIyLjVWMjJaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIxOTNfMjI0NiI+CjxyZWN0IHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgcng9IjYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgFlowIcmpFill as ReactComponent };